<template>
	<div>{{TabItem}}</div>
</template>

<script>
	export default{
		props: ['routePath'],
		computed: {
			//注意当切换成切其他的tab时，这个值也会改变	
			TabItem() {
				if (this.routePath) {
					return {};
				}
				if (this.$route.meta.menu) {
					return this.$route.meta.menu[this.$route.fullPath];
				}
				return {};
			}
		},
		created() {
			console.log('set-create')
		},
		mounted() {
			console.log('set-mounted')
		}
	}
</script>

<style>
</style>
